import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Transition as _Transition, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/pencil-gray.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w-full h-screen fixed top-0 left-0 flex items-start justify-center bg-black/75 z-[1000]" }
const _hoisted_3 = { class: "flex gap-2 items-center" }
const _hoisted_4 = { class: "text-xl font-semibold" }
const _hoisted_5 = { key: 0 }

import { parseQcAbnahmeAnswers } from "@/utils/parse-qc-abnahme-answers";
import QuestionnaireAnswerReview from "../Questionnaire/parts/QuestionnaireAnswerReview.vue";
import QuestionnaireFinalScreen from "../Questionnaire/parts/QuestionnaireFinalScreen.vue";
import QuestionnaireModal from "../Questionnaire/parts/QuestionnaireModal.vue";
import { computed } from "vue";
import QuestionnaireProgressBar from "../Questionnaire/parts/QuestionnaireProgressBar.vue";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  isAbnahmeQcModalOpen: boolean;
  currentPhaseProgress: any;
};

type Emits = {
  (event: "onClose"): void;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'QCAbnahmeDetailsModal',
  props: {
    isAbnahmeQcModalOpen: { type: Boolean },
    currentPhaseProgress: {}
  },
  emits: ["onClose"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;
const isModalOpen = computed(() => props.isAbnahmeQcModalOpen);
const { t } = useTranslate();

const metadata = computed(() => {
  let tempMetadata: any = [];
  let qcActions = props.currentPhaseProgress?.qcActions;
  if (qcActions[0].metadata) {
    let type: "qc" | "abnahme" | "appointment" = "qc";
    if (qcActions[0].action === 1) {
      type = "appointment";
    } else if ([2, 3, 4].includes(qcActions[0].action)) {
      type = "abnahme";
    } else {
      type = "qc";
    }
    if (qcActions && qcActions[0].metadata) {
      tempMetadata = parseQcAbnahmeAnswers(qcActions[0].metadata, type);
    }
  } else if (qcActions[0].description) {
    tempMetadata.push({
      question: t("questionnaire.what_data_is_missing").value,
      answer: qcActions[0].description,
    });
  }

  return tempMetadata;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "nested" }, {
    default: _withCtx(() => [
      (isModalOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(QuestionnaireModal, {
                class: "modal",
                onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClose')))
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[1] || (_cache[1] = _createElementVNode("img", {
                      class: "w-4 h-4 cursor-pointer",
                      src: _imports_0,
                      alt: "Pencil"
                    }, null, -1)),
                    _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)("phase.review")) + " " + _toDisplayString(__props.currentPhaseProgress.phaseStatus.id === 8 ? "QC" : "Abnahme"), 1)
                  ])
                ]),
                "progress-bar": _withCtx(() => [
                  _createVNode(QuestionnaireProgressBar, {
                    progress: 100,
                    warning: true
                  })
                ]),
                content: _withCtx(() => [
                  _createVNode(QuestionnaireFinalScreen, {
                    title: _unref(t)('questionnaire.submit').value,
                    "sub-title": "",
                    status: "waiting"
                  }, null, 8, ["title"]),
                  (metadata.value && metadata.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(QuestionnaireAnswerReview, { answers: metadata.value }, null, 8, ["answers"])
                      ]))
                    : _createCommentVNode("", true),
                  _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1))
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})